// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zzoq","left":"styles_left___QGUV"};